/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-cond-assign */
/* eslint-disable import/no-extraneous-dependencies */
import { Box, Code, FormControl, FormErrorMessage, HStack, Text, useTheme as useChakraTheme } from '@chakra-ui/core';
import React, { useState, useEffect, useCallback, useMemo, useRef, FC } from 'react';
import DOMPurify from 'dompurify';
import isString from 'lodash/isString';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
import isEqual from 'lodash/isEqual';
import { useTranslation } from 'react-i18next';
import { useStoreState } from '../../../../models/hooks';
import useHireFormErrorHandling, { ValidationType, ValidationTypeEnum } from '../hooks/useHireFormErrorHandling';
import { attachDataTag } from '../utils';

// --- Custom Quill Blot for Tags ---
/* istanbul ignore next */
const Inline = Quill.import('blots/inline');
class TagBlot extends Inline {
  static blotName = 'tag';

  static tagName = 'span';

  static create(value: string | boolean) {
    const node = super.create(value);
    if (isString(value)) {
      node.setAttribute('data-tag', value);
    } else if (value === true) {
      node.setAttribute('data-tag', 'true');
    }
    node.classList.add('quill-custom-tag');
    return node;
  }

  static formats(node: HTMLElement) {
    return node.getAttribute('data-tag') || undefined;
  }
}
Quill.register(TagBlot);

interface TextSchemaBuilderProps extends Omit<React.ComponentProps<typeof Box>, 'onChange' | 'value'> {
  // value?: LabelSchema;
  fieldId: string;
  innerPath: string;
  label: string;
  onLabelChange: (newHtmlLabelForCurrentLanguage: string) => void;
  placeholder?: string;
  startWithEditView?: boolean;
  language: string;
  hideTextCounter?: boolean;
  maxLength?: number;
  isAdvanced: boolean;
}

const TextInput: FC<TextSchemaBuilderProps> = React.memo(
  ({
    fieldId,
    innerPath,
    label: initialHtmlForCurrentLang,
    onLabelChange,
    placeholder,
    startWithEditView = false,
    language,
    hideTextCounter = false,
    maxLength = 500,
    isAdvanced,
    ...boxProps
  }: TextSchemaBuilderProps) => {
    const { t } = useTranslation('hrFormTemplate');
    const chakraTheme = useChakraTheme();

    const quillRef = useRef<ReactQuill>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const { tags = [] } = useStoreState((state) => state.formBuilder);

    const [currentHtml, setCurrentHtml] = useState<string>(attachDataTag(initialHtmlForCurrentLang ?? ''));

    useEffect(() => {
      setCurrentHtml(attachDataTag(initialHtmlForCurrentLang ?? ''));
    }, [initialHtmlForCurrentLang]);

    // --- Error Handling ---
    const { validate, error: validationError, hasError } = useHireFormErrorHandling({
      targetId: fieldId,
      innerPath,
      validationType: ValidationTypeEnum.TEXT as ValidationType,
      onFocus: () => {
        setTimeout(() => quillRef.current?.focus(), 0);
      },
      limit: maxLength,
      isAdvanced: isAdvanced || false,
    });

    const handleBlur = useCallback(
      (_previousRange: any, source: string, _editor: any) => {
        if (source !== 'silent' && (source === 'user' || source === 'api' || source === 'enterKey')) {
          const sanitizedHtml = DOMPurify.sanitize(currentHtml, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'span'],
            ALLOWED_ATTR: ['data-tag', 'class'],
          });
          const cleanedHtml = sanitizedHtml.trim() === '<p><br></p>' ? '' : sanitizedHtml;

          const plainTextContent = quillRef.current?.getEditor().getText().trim() ?? '';
          const valueToValidate = { [language]: plainTextContent };
          validate(valueToValidate);

          onLabelChange(cleanedHtml);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [currentHtml, language, initialHtmlForCurrentLang, onLabelChange, validate, maxLength],
    );

    const handleBlurRef = useRef(handleBlur);
    useEffect(() => {
      handleBlurRef.current = handleBlur;
    }, [handleBlur]);

    // --- Quill Modules ---
    const quillModules = useMemo(
      () => ({
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ],
        keyboard: {
          bindings: {
            enter: {
              key: 13,
              shiftKey: false,
              handler: () => {
                if (quillRef.current) {
                  const editor = quillRef.current.getEditor();
                  handleBlurRef.current(editor.getSelection(), 'enterKey', editor);
                }
                return false;
              },
            },
          },
        },
      }),
      [],
    );

    // --- Editor Interaction Callbacks ---
    const focusEditor = useCallback(() => {
      if (quillRef.current) {
        const editor = quillRef.current.getEditor();
        editor.focus();
        const length = editor.getLength();
        editor.setSelection(length, length);
      }
    }, []);

    useEffect(() => {
      focusEditor();
    }, [focusEditor]);

    const handleQuillChange = useCallback(
      (content: string, _delta: any, source: string, editor: ReactQuill.UnprivilegedEditor) => {
        setCurrentHtml(content);

        if (source === 'user') {
          const plainText = editor.getText();
          const valueToValidate = { [language]: plainText };
          validate(valueToValidate);

          // --- Custom Tagging Logic ---
          const quillInstance = quillRef.current?.getEditor();
          if (quillInstance) {
            const textContent = quillInstance.getText();

            quillInstance.formatText(0, textContent.length, TagBlot.blotName, false, 'silent');

            const regex = /\[([^\]]+)\]/g;
            let match;
            while ((match = regex.exec(textContent)) !== null) {
              const tagName = match[1];
              if (tags.includes(tagName)) {
                quillInstance.formatText(match.index, match[0].length, TagBlot.blotName, tagName, 'silent');
              }
            }
          }
        }
      },
      [language, validate, tags],
    );

    // --- Click Outside Logic ---
    useEffect(() => {
      const handleDocumentClick = (event: MouseEvent) => {
        if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
          const editor = quillRef.current?.getEditor();
          if (editor) {
            handleBlur(editor.getSelection(), 'user', editor);
          }
        }
      };

      document.addEventListener('mousedown', handleDocumentClick);

      return () => {
        document.removeEventListener('mousedown', handleDocumentClick);
      };
    }, [handleBlur]);

    // --- Character Counter ---
    const characterCount = useMemo(() => {
      if (quillRef.current) {
        return quillRef.current.getEditor().getText().length - 1;
      }
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = currentHtml;
      return tempDiv.textContent?.length || 0;
    }, [currentHtml]);

    const placeholderText = placeholder || t('formBuilder.editorPlaceholder.text') || 'Enter text...';

    return (
      <Box w="100%" {...boxProps} ref={containerRef} position="relative" zIndex={2}>
        <HStack alignItems="start" spacing={2}>
          <FormControl isInvalid={hasError} flexGrow={1}>
            <Box position="relative" className="quill-editor-wrapper">
              <Box sx={{ position: 'absolute', top: 3, right: 5, zIndex: 1 }}>
                <HStack>
                  <Text fontSize="xs" color="gray.500">
                    {t('newLineHint.press') || 'Press'}
                  </Text>
                  <Code fontSize="xs" fontWeight="bold" px={2} py={0.5} borderRadius={chakraTheme.radii.md} colorScheme="blue">
                    Shift + &#x21B5;
                  </Code>
                  <Text fontSize="xs" color="gray.500">
                    {t('newLineHint.forNewLine') || 'for new line'}
                  </Text>
                </HStack>
              </Box>
              <ReactQuill
                theme="snow"
                value={currentHtml}
                placeholder={placeholderText}
                modules={quillModules}
                onChange={handleQuillChange}
                onBlur={handleBlur}
                ref={quillRef}
                style={{
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                  whiteSpace: 'pre-wrap',
                  backgroundColor: chakraTheme.colors.white,
                  border: hasError ? `1px solid ${chakraTheme.colors.red[500]}` : `unset`,
                }}
                readOnly={boxProps.isDisabled}
              />
            </Box>
            {hasError && validationError && (
              <FormErrorMessage mt={1} fontSize="xs">
                {validationError}
              </FormErrorMessage>
            )}
          </FormControl>
          {!hideTextCounter && (
            <Text
              fontSize="xs"
              color={characterCount > maxLength ? chakraTheme.colors.red[500] : chakraTheme.colors.gray[500]}
              whiteSpace="nowrap"
              pt={0}
            >
              {characterCount}/{maxLength}
            </Text>
          )}
        </HStack>
      </Box>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.label === nextProps.label &&
      isEqual(prevProps.value, nextProps.value) &&
      prevProps.onLabelChange === nextProps.onLabelChange &&
      prevProps.placeholder === nextProps.placeholder &&
      prevProps.startWithEditView === nextProps.startWithEditView &&
      prevProps.language === nextProps.language &&
      prevProps.hideTextCounter === nextProps.hideTextCounter &&
      prevProps.maxLength === nextProps.maxLength &&
      prevProps.isDisabled === nextProps.isDisabled &&
      prevProps.onClick === nextProps.onClick
    );
  },
);

export default TextInput;
